import { ConfirmDialog } from '~/components/ConfirmDialog/ConfirmDialog';
import { ContextMenu } from '~/components/ContextMenu/ContextMenu';
import { useDeleteTeamMutation } from '../../mutations';
import { Table } from '~/components/Table/Table';
import { useDialog } from '~/hooks/useDialog';
import { toast } from 'react-toastify';
import { Team } from '~/apis/ssf';

interface Props {
  teams: Team[];
  isLoading: boolean;
}

function Row({ team }: { team: Team }) {
  const mutation = useDeleteTeamMutation();
  const dialog = useDialog();

  async function handleDelete() {
    await toast.promise(mutation.mutateAsync(team.id), {
      pending: 'Tar bort lag...',
      success: 'Laget har tagits bort',
    });
  }

  return (
    <Table.Row>
      <Table.Col>{team.name}</Table.Col>
      <Table.Col>{team.club.name}</Table.Col>
      <Table.Col>{`${team.division.name} - ${team.division.series.name}`} </Table.Col>
      <Table.Col align="right">
        <Table.Context
          items={[
            <ContextMenu.Item label="Redigera" key="edit" to={`${team.id}/edit`} />,
            <ContextMenu.Item label="Ta bort" key="delete" onClick={dialog.open} danger />,
          ]}
        />
      </Table.Col>

      <ConfirmDialog {...dialog} isLoading={mutation.isPending} onConfirm={handleDelete} />
    </Table.Row>
  );
}

export function TeamListTable({ teams, isLoading }: Props) {
  return (
    <Table bg="even">
      <Table.Head>
        <Table.Row>
          <Table.Col as="th">Namn</Table.Col>
          <Table.Col as="th">Förening</Table.Col>
          <Table.Col as="th">Serie</Table.Col>
          <Table.Col as="th" />
        </Table.Row>
      </Table.Head>
      <Table.Body>{isLoading ? <Table.Loading cols={4} /> : teams.map(t => <Row team={t} key={t.id} />)}</Table.Body>
    </Table>
  );
}
